import {VEHICLE_DETAILS} from '../utils/constant';

export function updateHasChangingFlag(value) {
    return {
        type: VEHICLE_DETAILS.CHANGING,
        state: {
            isChanging: value
        }
    }
}